import { useEffect, useState } from "react";

import {
  dismissMutationError,
  subscribeMutationErrors,
  type MutationErrorEntry,
} from "../state/mutationErrorStore";
import styles from "./MutationErrorToast.module.css";

// App-root subscriber for the shared mutation-error store. Renders a stack of
// dismissible error toasts so a failed mutation - including a fire-and-forget
// `.mutate()` that renders nothing itself - is always visible to the operator
// instead of silently reverting. Auto-dismisses after a few seconds; the
// operator can also close each one.
export const MutationErrorToast = () => {
  const [entries, setEntries] = useState<MutationErrorEntry[]>([]);

  useEffect(() => subscribeMutationErrors(setEntries), []);

  useEffect(() => {
    if (entries.length === 0) return;
    const timers = entries.map((e) =>
      window.setTimeout(() => dismissMutationError(e.id), 8000),
    );
    return () => timers.forEach((t) => window.clearTimeout(t));
  }, [entries]);

  if (entries.length === 0) return null;

  return (
    <div className={styles.stack} role="alert" aria-live="assertive">
      {entries.map((e) => (
        <div key={e.id} className={styles.toast}>
          <span className={styles.msg}>{e.message}</span>
          <button
            type="button"
            className={styles.close}
            aria-label="Dismiss"
            onClick={() => dismissMutationError(e.id)}
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
};
